export default "__VITE_ASSET__Cuv4ybx1__"